import PAApi from './_paApi.js';
import httpClient from '@/apis/base/httpclient';

class PAGLPayrollExpenseSalaryAPI extends PAApi {
  constructor() {
    super();
  }
  controllerName = 'PaGLPayrollExpenses';

  /**
   * Lấy ra danh sách bảng lương
   * @param {*} payload
   * @returns
   * NNLinh 15.11.2022
   */
  async getListSalaryExpenses(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/DataSalaryExpensive',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Lấy ra dữ liệu hạch toán bảng lương chi tiết
   * @param {*} payload
   * @returns
   * NNLinh 15.11.2022
   */
  async getSalaryExpensesDetail(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/DataSalaryExpensiveDetail',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Lấy ra dữ liệu hạch toán bảng lương chi tiết
   * @param {*} payload
   * @returns
   * NNLinh 15.11.2022
   */
  async getDataGenerateVoucher(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/DataGenerateVoucher',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Kiểm tra sinh chứng từ
   * @param {*} payload
   * @returns
   * NNLinh 15.11.2022
   */
  async getVoucherByRelationRefId(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/VoucherByRelationRefId',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }
}

export default new PAGLPayrollExpenseSalaryAPI();
